import React, { useState, useEffect, useRef } from 'react'
import Nang from '../images/nmz.png'
import { FaFacebook, FaGithub, FaLinkedinIn, FaDownload } from "react-icons/fa";
import { BiLogoGmail } from "react-icons/bi";
import Button from './Button';
import { FaArrowRight } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import CV from '../images/cv/Nang_Myintzu.pdf'
import Bubbles from './Bubbles';

const roles = [
  'Chief Technology Officer',
  'Full-Stack Architect',
  'Product Strategist',
  'Engineering Leader',
];

const Banner = () => {
  const [currentRole, setCurrentRole] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const heroRef = useRef(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    const role = roles[currentRole];
    let timeout;

    if (!isDeleting && displayText === role) {
      timeout = setTimeout(() => setIsDeleting(true), 2000);
    } else if (isDeleting && displayText === '') {
      setIsDeleting(false);
      setCurrentRole((prev) => (prev + 1) % roles.length);
    } else {
      timeout = setTimeout(
        () => {
          setDisplayText(
            isDeleting
              ? role.substring(0, displayText.length - 1)
              : role.substring(0, displayText.length + 1)
          );
        },
        isDeleting ? 40 : 80
      );
    }
    return () => clearTimeout(timeout);
  }, [displayText, isDeleting, currentRole]);

  const downloadCV = () => {
    const anchor = document.createElement('a');
    anchor.href = CV;
    anchor.download = 'NangMyintzu.pdf';
    anchor.click();
  }

  const sendMail = () => {
    window.location.href = 'mailto:nangmyintzu89@gmail.com';
  }

  const socialLinks = [
    { icon: <FaFacebook />, url: "https://www.facebook.com/profile.php?id=100010036154961&mibextid=ZbWKwL", label: "Facebook", delay: 300 },
    { icon: <FaGithub />, url: "https://github.com/NangMyintzu-Yuki", label: "GitHub", delay: 200 },
    { icon: <FaLinkedinIn />, url: "https://www.linkedin.com/in/nangmyintzu/", label: "LinkedIn", delay: 100 },
  ];

  return (
    <section
      ref={heroRef}
      className="relative bg-primary-bg py-24 mt-16 overflow-hidden noise-overlay"
      id="hero"
    >
      {/* Gradient mesh background */}
      <div className="absolute inset-0 gradient-mesh pointer-events-none" />

      {/* Grid pattern */}
      <div className="absolute inset-0 grid-pattern pointer-events-none opacity-50" />

      <Bubbles count={15} />

      {/* Decorative orbs */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-accent/5 rounded-full blur-3xl animate-float-slow pointer-events-none" />
      <div className="absolute bottom-10 left-10 w-56 h-56 bg-accent/3 rounded-full blur-3xl animate-float-fast pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-8 gap-8 items-center">

          {/* Profile Image */}
          <div
            className="lg:col-span-2 flex justify-center"
            style={{
              animation: isVisible ? 'slideInLeft 0.8s ease-out forwards' : 'none',
              opacity: isVisible ? undefined : 0,
            }}
          >
            <div className="relative group">
              {/* Single animated ring */}
              <div className="absolute -inset-1 rounded-full border border-accent/25 animate-pulse-glow" />

              {/* Main image - Large upscale */}
              <div className="relative w-[220px] h-[220px] lg:w-[280px] lg:h-[280px] rounded-full overflow-hidden border-2 border-accent/20">
                <img
                  src={Nang}
                  alt="Nang Myintzu — Chief Technology Officer at WeTech"
                  className="w-full h-full object-cover object-top scale-110 pt-2"
                />
              </div>

              {/* Floating decorators */}
              <div className="absolute -bottom-2 -right-2 w-4 h-4 bg-accent/30 rounded-full animate-float" />
              <div className="absolute -top-2 -left-2 w-3 h-3 bg-accent/20 rounded-full animate-float-slow" />
            </div>
          </div>

          {/* Content */}
          <div
            className="lg:col-span-5 text-center lg:text-left"
            style={{
              animation: isVisible ? 'fadeInUp 0.8s 0.2s ease-out forwards' : 'none',
              opacity: isVisible ? undefined : 0,
            }}
          >
            <p className="text-accent font-semibold text-base lg:text-lg mb-2 tracking-wider uppercase">
              Nang Myintzu
            </p>

            <h1 className="font-bold text-white text-3xl sm:text-4xl lg:text-5xl mb-2 min-h-[2.5em] lg:min-h-[1.5em]">
              <span className="inline-block">{displayText}</span>
              <span className="inline-block w-[3px] h-[1em] bg-accent ml-1 align-middle typewriter-cursor" />
            </h1>

            <p className="text-gray-dark text-lg lg:text-xl mb-4 font-light tracking-wide">WeTech</p>

            <p className="text-gray leading-relaxed max-w-xl mx-auto lg:mx-0 text-sm lg:text-base">
              Technology leader with deep expertise in full-stack development, scalable architecture,
              and product strategy. Building ventures that drive digital transformation.
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-3 lg:gap-4 mt-8">
              <Button
                onClick={downloadCV}
                icon={<FaDownload size="14px" />}
                position="start"
                className="magnetic-btn bg-accent text-primary-bg rounded-xl font-semibold px-6 py-3.5 border border-accent hover:bg-accent-dark transition-all duration-300 text-sm shadow-accent hover:shadow-accent-lg ripple-container"
              >
                Download CV
              </Button>
              <Link to="/about">
                <Button
                  icon={<FaArrowRight size="16px" />}
                  className="magnetic-btn bg-transparent text-accent rounded-xl font-semibold px-6 py-3.5 border border-accent/40 hover:bg-accent/10 hover:border-accent transition-all duration-300 text-sm ripple-container"
                >
                  More About Me
                </Button>
              </Link>
            </div>
          </div>

          {/* Social Links */}
          <div className="lg:col-span-1 flex justify-center lg:justify-end">
            <ul className="flex lg:flex-col sm:flex-row gap-3 lg:gap-4 items-center">
              {socialLinks.map((social, i) => (
                <li
                  key={i}
                  className="border border-primary-border p-2.5 rounded-full text-accent hover:border-accent/60 hover:text-white hover:bg-accent/10 hover:shadow-accent text-xl cursor-pointer transition-all duration-300 hover:scale-110 active:scale-95"
                  style={{
                    animation: isVisible ? `fadeInDown 0.5s ${0.5 + i * 0.1}s ease-out forwards` : 'none',
                    opacity: isVisible ? undefined : 0,
                  }}
                >
                  <a href={social.url} target="_blank" rel="noopener noreferrer" aria-label={social.label}>
                    {social.icon}
                  </a>
                </li>
              ))}
              <li
                className="border border-primary-border p-2.5 rounded-full text-accent hover:border-accent/60 hover:text-white hover:bg-accent/10 hover:shadow-accent text-xl cursor-pointer transition-all duration-300 hover:scale-110 active:scale-95"
                onClick={sendMail}
                role="button"
                aria-label="Send email"
                style={{
                  animation: isVisible ? `fadeInDown 0.5s 0.8s ease-out forwards` : 'none',
                  opacity: isVisible ? undefined : 0,
                }}
              >
                <BiLogoGmail />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Banner
